// extracted by mini-css-extract-plugin
module.exports = {"body":"TerminalBlock_body__1Hf9E","off":"TerminalBlock_off__1VETN"};